import { ITextureStyle } from "../../../../base/domain/drawing";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface ITextureStylePropertyEditable {
  textureStyle(): IPropertyEditable<ITextureStyle>;
}

export function instanceOfITextureStylePropertyEditable(instance: any): instance is ITextureStylePropertyEditable {
  return instance
      && instance.textureStyle
      && instanceOfIPropertyEditable<ITextureStyle>(instance.textureStyle());
}
